import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-black text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="bg-white p-1.5 rounded-lg inline-flex items-center justify-center">
                <img 
                  src="https://assets.auxodev.dk/assets/c15c4fdc-8908-4ddc-a4c7-4bd7c9025029/dapao-logo-women-embrace.webp" 
                  alt="DAPAO logo with two women embracing" 
                  className="h-10 w-10 object-contain"
                />
              </div>
              <div className="flex flex-col leading-none">
                <span className="text-3xl font-black tracking-tighter text-white">DAPAO</span>
              </div>
            </div>
            <p className="text-white/80 leading-relaxed max-w-xs">
              En non-profit organisation der arbejder for ligestilling, dialog og solidaritet mellem Danmark og Palæstina.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6 uppercase tracking-wider">Om os</h4>
            <ul className="space-y-4">
              <li><Link to="/om-os/vores-historie" className="text-white/70 hover:text-white transition-colors">Vores Historie</Link></li>
              <li><Link to="/om-os/vision-mission" className="text-white/70 hover:text-white transition-colors">Vision & Mission</Link></li>
              <li><Link to="/om-os/vores-arbejde" className="text-white/70 hover:text-white transition-colors">Vores Arbejde</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6 uppercase tracking-wider">Hurtige links</h4>
            <ul className="space-y-4">
              <li><Link to="/#membership" className="text-white/70 hover:text-white transition-colors">Bliv medlem</Link></li>
              <li><Link to="/#contribution" className="text-white/70 hover:text-white transition-colors">Giv et bidrag</Link></li>
              <li><Link to="/galleri" className="text-white/70 hover:text-white transition-colors">Galleri</Link></li>
              <li><Link to="/kontakt" className="text-white/70 hover:text-white transition-colors">Kontakt os</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6 uppercase tracking-wider">Kontakt</h4>
            <address className="not-italic text-white/70 space-y-3">
              <div className="flex items-start gap-2">
                <MapPin className="h-4 w-4 text-white/60 shrink-0 mt-1" />
                <div>
                  <p>Bernstorffsvej 86 1.Tv</p>
                  <p>2900 Hellerup</p>
                </div>
              </div>
              <div className="pt-2 space-y-2">
                <p className="flex items-center gap-2">
                  <Mail className="h-4 w-4 text-white/60 shrink-0" />
                  <a href="mailto:dapawomen@gmail.com" className="hover:text-white transition-colors">dapawomen@gmail.com</a>
                </p>
                <p className="flex items-center gap-2">
                  <Phone className="h-4 w-4 text-white/60 shrink-0" />
                  <a href="tel:+4571729199" className="hover:text-white transition-colors">71 72 91 99</a>
                </p>
              </div>
              <p className="pt-1 text-sm text-white/50">CVR: 34785708</p>
            </address>
          </div>
        </div>

        <div className="pt-12 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-white/50 text-sm">
            © {new Date().getFullYear()} DAPAO. Alle rettigheder forbeholdes.
          </p>
        </div>
      </div>
    </footer>
  );
}
